import { Box, Drawer, GlobalStyles } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import axios from '@/utils/api/axios';
import { LegalEntityNewEditForm } from '@/sections/settings/legal-entities/legal-entity-new-edit-form';
import { IOrganizationItem } from '@/types/organization';
import { LoadingScreen } from '@components/feedback/loading-screen';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  organization: IOrganizationItem;
};

export function OrderLegalEntityNewEditForm({ open, onClose, organization }: Props) {
  const fetchAllCountries = async () => {
    const response = await axios.get(`countries/all`);
    return response.data;
  };
  const { data: countriesData, isLoading: isLoadingCountries } = useQuery(
    ['countries'],
    fetchAllCountries
  );

  return (
    <>
      <GlobalStyles styles={{ '.pac-container': { zIndex: 999999 } }} />
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        slotProps={{
          backdrop: { invisible: false },
        }}
        ModalProps={{
          BackdropProps: {
            style: {
              backgroundColor: 'rgba(22, 22, 22, 0.7)',
            },
          },
        }}
        PaperProps={{
          sx: { width: '60vw' },
        }}
      >
        <Box sx={{ p: 3 }}>
          {isLoadingCountries ? (
            <LoadingScreen />
          ) : (
            <LegalEntityNewEditForm
              organization={organization}
              countries={countriesData?.data}
              onSuccess={onClose}
              onCancel={onClose}
            />
          )}
        </Box>
      </Drawer>
    </>
  );
}
